<template>
  <div class="box">
    <div class="bread_nav clearfix">
      <div class="return clearfix" @click="$router.go(-1)">
        <img src="../assets/img/返回.png" alt />
        返回我的课程
      </div>

      <el-breadcrumb separator-class="el-icon-arrow-right">
        <el-breadcrumb-item @click="$router.go(-1)" style="cursor: pointer"
          >学堂</el-breadcrumb-item
        >
        <el-breadcrumb-item>组卷模考</el-breadcrumb-item>
      </el-breadcrumb>
    </div>

    <div class="container">
      <!-- <div class="content">
        <img src="../assets/img/zujuan.png" alt="" />
        <div class="text">
          综合做题进度、薄弱知识点、高频考点，从章节练习、历年真题中抽取相关题目，为你定制与考点范围、难度匹配的模考，检测能力
        </div>
      </div> -->
      <!-- <button @click="starMock">开始模考</button> -->

      <button v-for="(item,index) in btnList" :key="index" @click="goNext(item)">{{item.title}}</button>

      <button @click="goLog()" class="logBtn">
        <img src="../assets/img/time2.png" alt="" />
        历史模考
      </button>
    </div>
  </div>
</template>

<script>
import { Queschild,aiMock } from "@/api/index";
export default {
  name: "",
  data() {
    return {
      classList: '',
      btnList:'',
    };
  },
  computed: {},
  watch: {},
  methods: {
    // 模考列表
    aiMockM(){
      aiMock(this.$route.query.id).then(res=>{
        this.btnList = res.data
      })
    },
    // 历史模考
    goLog() {
      this.$router.push({
        path: "questionLog",
        query: { course_id: this.$route.query.course_id, pageType: 2 },
      });
    },
    // 下一页
    goNext(item){
      if(item.ai_type==0){
        if (item.type == 3) {
          this.$router.push({
            path: "exam_list",
            query: {
              course_id: item.course_id,
              id: item.id,
              title: item.title,
              toptitle: item.title,
              learn_type:item.type
            }
          });
        } else {
          if(item.type==0){
            this.$router.push({
              path: "exam",
              query: {
                course_id: item.course_id,
                test_id: item.test_id,
                rule_tag: 'ai_chapter',
                cid: item.cid,
                course_chapter_id:item.id
              }
            });
          }else{
            this.$router.push({
              path: "exam",
              query: {
                course_id: item.course_id,
                test_id: item.test_id,
                rule_tag: 'exam_list_template',
                cid: item.cid,
                course_chapter_id:item.id
              }
            });
          }
        }
        
      }else if(item.ai_type==2){
        //模拟考试
        this.$router.push({
          path: "exam",
          query: {
            course_id: item.course_id,
            test_id: item.test_id,
            rule_tag: item.rule_tag,
            cid: item.cid,
            course_chapter_id: item.id,
            is_zujuan:1
          },
        });
      }else if(item.ai_type==7){
        // 章节测试（开发新列表）
        this.$router.push('/aiExamList?chapter_id='+this.$route.query.id)
      }
    },
    // moni() {
    //   Queschild(this.$route.query.course_id, this.$route.query.id).then(
    //     (res) => {
    //       this.classList = res;
    //       this.starMock()
    //     }
    //   );
    // },
    // starMock() {
    //   if (this.classList.length == 0)
    //     return alert("没找到适合题型，请联系客服");
    //   this.$router.push({
    //     path: "exam",
    //     query: {
    //       course_id: this.classList[0].logic_content.data.course_id,
    //       test_id: this.classList[0].logic_content.data.test_id,
    //       rule_tag: this.classList[0].logic_content.temp_type,
    //       cid: this.classList[0].logic_content.data.cid,
    //       course_chapter_id: this.classList[0].logic_content.data.id,
    //       is_zujuan:1
    //     },
    //   });
    // },
  },
  created() {
      this.aiMockM();
  },
};
</script>

<style lang='scss' scoped>
.box {
  width: 1368px;
  margin: 0 auto;
  .bread_nav {
    padding: 12px 0 12px 74px;
    background: rgba(255, 255, 255, 1);
    border-radius: 4px;
    border: 1px solid rgba(238, 238, 238, 1);
    margin-bottom: 16px;
    .return {
      font-size: 16px;
      font-weight: 500;
      color: rgba(43, 43, 43, 1);
      float: left;
      margin-right: 45px;
      line-height: 28px;
      cursor: pointer;
      img {
        float: left;
        width: 28px;
        height: 28px;
        margin-right: 12px;
      }
    }
    .el-breadcrumb {
      float: left;
      margin-top: 8px;
    }
  }
  .container {
    padding: 41px 0 200px 0;
    background: white;
    margin-top: 16px;
    width: 100%;
    text-align: center;
    position: relative;
    display: flex;
    flex-direction: column;
    align-items: center;
    .content {
      width: 292px;
      margin: 0 auto;
      background: #ffffff;
      box-shadow: 0px 5px 10px 0px rgba(15, 0, 67, 0.05);
      border-radius: 6px;
      img {
        width: 100%;
      }
      .text {
        padding: 15px 22px 29px 44px;
        font-size: 12px;
        font-weight: 500;
        color: #333333;
        text-align: left;
      }
    }
    button {
      cursor: pointer;
      margin-top: 32px;
      width: 208px;
      height: 46px;
      background: #fada1e;
      border-radius: 23px;
      font-size: 18px;
      font-weight: 500;
      color: #333333;
      border: 0;
    }
    .logBtn {
      width: 110px;
      height: 38px;
      background: #fada1e;
      border-radius: 19px;
      display: flex;
      align-items: center;
      justify-content: center;
      border: 0;
      cursor: pointer;
      position: absolute;
      top: 20px;
      right: 45px;
      font-size: 14px;
      font-weight: 500;
      color: #333333;
      img {
        width: 21px;
        margin-right: 4px;
      }
    }
  }
}
</style>
